import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "notif-popup" }
const _hoisted_2 = { class: "notif-head" }
const _hoisted_3 = { class: "notif-head-left" }
const _hoisted_4 = {
  key: 0,
  class: "notif-cb-label",
  title: "Selecionar todas"
}
const _hoisted_5 = ["checked"]
const _hoisted_6 = { class: "notif-head-right" }
const _hoisted_7 = {
  key: 0,
  class: "notif-confirm-bar"
}
const _hoisted_8 = { class: "notif-confirm-text" }
const _hoisted_9 = { class: "notif-confirm-btns" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = ["disabled"]
const _hoisted_12 = {
  key: 1,
  class: "notif-list"
}
const _hoisted_13 = {
  key: 2,
  class: "notif-empty"
}
const _hoisted_14 = {
  key: 3,
  class: "notif-list"
}
const _hoisted_15 = ["checked", "onChange"]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "notif-item-title" }
const _hoisted_18 = {
  key: 0,
  class: "notif-pill"
}
const _hoisted_19 = { class: "notif-item-text" }
const _hoisted_20 = {
  key: 0,
  class: "notif-item-when"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SkeletonRow = _resolveComponent("SkeletonRow")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.visibleNotifications.length > 0)
          ? (_openBlock(), _createElementBlock("label", _hoisted_4, [
              _createElementVNode("input", {
                ref: "selectAllEl",
                type: "checkbox",
                class: "notif-cb",
                checked: _ctx.isAllSelected,
                onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleSelectAll && _ctx.toggleSelectAll(...args)))
              }, null, 40, _hoisted_5)
            ]))
          : _createCommentVNode("", true),
        _cache[8] || (_cache[8] = _createElementVNode("span", { class: "notif-title" }, "Notificações", -1))
      ]),
      _createElementVNode("div", _hoisted_6, [
        (_ctx.hasSelected)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("button", {
                class: "notif-act-btn notif-act-clear",
                type: "button",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.requestAction('limpar')))
              }, " Limpar "),
              _createElementVNode("button", {
                class: "notif-act-btn notif-act-view",
                type: "button",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.requestAction('visualizar')))
              }, " Visualizar ")
            ], 64))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          class: "notif-x-btn",
          type: "button",
          "aria-label": "Fechar",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('close')))
        }, "✕")
      ])
    ]),
    (_ctx.confirmAction)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("span", _hoisted_8, [
            _cache[9] || (_cache[9] = _createTextVNode(" Tem certeza que quer ", -1)),
            _createElementVNode("strong", null, _toDisplayString(_ctx.confirmAction), 1),
            _createTextVNode(" " + _toDisplayString(_ctx.selectedIds.size) + " notificação" + _toDisplayString(_ctx.selectedIds.size !== 1 ? 'ões' : '') + "? ", 1)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("button", {
              class: "notif-confirm-yes",
              type: "button",
              disabled: _ctx.acting,
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.executeAction && _ctx.executeAction(...args)))
            }, _toDisplayString(_ctx.acting ? '...' : 'Sim'), 9, _hoisted_10),
            _createElementVNode("button", {
              class: "notif-confirm-cancel",
              type: "button",
              disabled: _ctx.acting,
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.confirmAction = null))
            }, " Cancelar ", 8, _hoisted_11)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showSkeleton)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (i) => {
            return _createVNode(_component_SkeletonRow, {
              key: i,
              columns: [70, 90, 30]
            })
          }), 64))
        ]))
      : (_ctx.notifications.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, "Nenhuma notificação."))
        : (_openBlock(), _createElementBlock("div", _hoisted_14, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleNotifications, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.id,
                class: _normalizeClass(["notif-item", { 'notif-item--sel': _ctx.selectedIds.has(item.id) }])
              }, [
                _createElementVNode("label", {
                  class: "notif-cb-label",
                  onClick: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"]))
                }, [
                  _createElementVNode("input", {
                    type: "checkbox",
                    class: "notif-cb",
                    checked: _ctx.selectedIds.has(item.id),
                    onChange: ($event: any) => (_ctx.toggleSelect(item.id))
                  }, null, 40, _hoisted_15)
                ]),
                _createElementVNode("button", {
                  class: "notif-body",
                  type: "button",
                  onClick: ($event: any) => (_ctx.$emit('open-notification', item))
                }, [
                  _createElementVNode("div", _hoisted_17, [
                    _createTextVNode(_toDisplayString(item.title) + " ", 1),
                    (!item.readAt)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_18, "novo"))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_19, _toDisplayString(item.message), 1),
                  (item.createdAt)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(_ctx.formatDateTime(item.createdAt)), 1))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_16)
              ], 2))
            }), 128)),
            _createElementVNode("button", {
              class: "notif-view-all",
              type: "button",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('view-all')))
            }, " Ver todas as notificações ")
          ]))
  ]))
}